<template>
  <div>
    <courses-and-instructors-desktop v-if="screenType === 'desktop'"></courses-and-instructors-desktop>
    <courses-and-instructors-mobile v-else></courses-and-instructors-mobile>
  </div>
</template>

<script>
import CoursesAndInstructorsDesktop from "@/components/Pages/Desktop/Dashboard/About/CoursesAndInstructorsDesktop";
import CoursesAndInstructorsMobile from "@/components/Pages/Mobile/Dashboard/About/CoursesAndInstructorsMobile";

export default {
  name: "CoursesAndInstructorsMain",
  components: {CoursesAndInstructorsMobile, CoursesAndInstructorsDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>